import type { PolicyResponse } from '@http/queries/useFetchPolicies';

export function canEditPolicy({
  policy,
  canEditAllDomains,
  canEditDomain,
}: {
  policy: Pick<PolicyResponse, 'domainScope' | 'auditEntryIds'>;
  canEditAllDomains: boolean;
  canEditDomain: (domainId: number) => boolean;
}): boolean {
  if (policy.domainScope === 'all-domains') {
    return canEditAllDomains;
  }

  // An empty scope holds no domain to have rights on, so it is not editable —
  // `every` over an empty list would say otherwise. `PolicyDomainAccessPolicy`
  // guards the same case, so the row actions match what a save would do.
  return (
    policy.auditEntryIds.length > 0 && policy.auditEntryIds.every(canEditDomain)
  );
}
